import { Icon } from '../Icon'
import React, { FC } from 'react'
import { ExchangeType } from './ExchangeType'

type Props = {
  icon: ExchangeType
  type?: 'theme' | 'color' | 'white' | 'dark'
  className?: string
}

export const ExchangeIcon: FC<Props> = ({
  icon,
  type = 'theme',
  className
}) => {
  return (
    <Icon className={className} icon={icon} collection='exchange' type={type} />
  )
}
